module.exports = __webpack_public_path__ + "static/media/standardBusIcon.2e3b1af8.svg";